/**
 * Deterministic color hash for a string — used to give every featured domain
 * card a unique but visually cohesive gradient thumbnail.
 *
 * Same input → same output on every render, so cards feel like they have
 * "their own" identity across page loads.
 */

// FNV-1a 32-bit hash — small, fast, well-distributed
function fnv1a(str) {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = (h * 0x01000193) >>> 0;
  }
  return h;
}

/**
 * Return two HSL colors for a diagonal gradient. All colors sit in a curated
 * hue range and a bounded saturation/lightness band so they stay editorial
 * and never clash with the brand's IKB (#002FA7) elsewhere on the page.
 */
export function gradientFromDomain(domain) {
  const sld = (domain || "").split(".")[0].toLowerCase() || "x";
  const h = fnv1a(sld);
  const hue1 = h % 360;
  const hue2 = (hue1 + 30 + ((h >> 8) % 40)) % 360;   // 30-70° hue shift
  const sat = 30 + ((h >> 16) % 25);                   // 30-55%
  const l1 = 82 + ((h >> 20) % 8);                     // 82-90% (soft, light)
  const l2 = 68 + ((h >> 24) % 8);                     // 68-76% (a shade deeper)
  return {
    from: `hsl(${hue1}, ${sat}%, ${l1}%)`,
    to: `hsl(${hue2}, ${sat + 5}%, ${l2}%)`,
    // Text color that pairs with both — a slightly desaturated deep-tone of
    // the same hue family, so the domain name reads without breaking mood.
    ink: `hsl(${hue1}, ${Math.min(sat + 10, 60)}%, 18%)`,
  };
}
